<template lang="">
	<ParentGraph
		:title="$t('pupload')"
		:show="errorImage"
	>
		<div
			class="position-relative"
			:style="errorImage ? 'top: -60px' : ''"
			v-if="!$siteconf.hideImages?.application"
		>
			<div
				class="p-5 bg-white details me-3 "
				v-if="errorImage"
			>
				<div class="d-flex">
					<span class="material-icons-outlined me-2">
						done
					</span>{{ $t('uploadText.text_1') }}
				</div>
				<div class="d-flex">
					<span class="material-icons-outlined me-2">
						done
					</span>{{ $t('uploadText.text_2') }}
				</div>
				<div class="d-flex">
					<span class="material-icons-outlined me-2">
						done
					</span>{{ $t('uploadText.text_3') }}
				</div>
			</div>
			<img
				ref="Image"
				:src="imageSrc"
				class=""
				:class="[errorImage ? 'graphwithText':'graph']"
				alt="upload"
			>
		</div>
	</ParentGraph>
</template>
<script>
import { imageErrorHandling } from "@/../public/js/imageErrorHandling"
export default {
	mixins: [imageErrorHandling],

	data() {
		return {
			errorImage: false,
			imageSrc: "/c/images/upload",
			fallbackImageSrc: "/s/images/Illustrations.png"
		};
	},
	mounted() {
		// Check the image dimensions on mount
		this.preloadImage(this.imageSrc, this.fallbackImageSrc);
	}
};
</script>
<style lang="scss" scoped>
.details{
    position: relative;
    left: 48px;
    background: white;
    border-radius: 100px;
    width: 90%;
    min-width: 360px;
    z-index: 1;
}
.graphwithText{
	position: absolute;
    top: 126px;
    z-index: 1;
    left: 100px;
}
.graph{

}
</style>